module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notes":"Notes"},"es":{"notes":"Notas"},"sw":{"notes":"Maelezo"}}')
  delete Component.options._Ctor
}
